import { useCallback } from 'react';

import Button from '@mui/material/Button';

import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';

import { toast } from 'src/components/snackbar';

import { useAuthContext } from 'src/auth/hooks';

export function SignOutButton({ onClose, ...other }) {
  const router = useRouter();
  const { signOut } = useAuthContext();

  const handleLogout = useCallback(async () => {
    try {
      signOut(); // Use our demo signOut function
      onClose?.();
      toast.success('Logged out successfully!');
      router.push(paths.auth.jwt.signIn);
    } catch (error) {
      console.error(error);
      toast.error('Unable to logout!');
    }
  }, [signOut, onClose, router]);

  return (
    <Button fullWidth variant="soft" size="large" color="error" onClick={handleLogout} {...other}>
      Logout
    </Button>
  );
}
